import { render, staticRenderFns } from "./CreateClientGroup.vue?vue&type=template&id=4cbb7d87&scoped=true"
import script from "./CreateClientGroup.vue?vue&type=script&lang=js"
export * from "./CreateClientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb7d87",
  null
  
)

export default component.exports